const funcion1 = {
    titulo: `Función: estructura mínima`,
    problemas: [
      {
        codigo:1,
        descripcion: `Una función es un conjunto de instrucciones que resuelven una parte del problema y que puede ser utilizado (llamado) desde diferentes partes de un programa.
La estructura de una función es:
<code>
function [nombre de función]() 
{ 
  [Algoritmo de la función] 
}
</code>
Como mínimo una función tradicional tiene un nombre y entre llaves el algoritmo de la misma. Con el nombre llamamos a la función, es decir, hacemos referencia a la misma.`,
programa: `function presentacion() {
  console.log("Hola mundo")
}
   
presentacion()
`,
        solucion: "'Hola mundo'"
      },{
        codigo:2,
        descripcion: `Las variables definidas dentro de una función solo se pueden acceder en dicha función.`,
programa: `function sumar() {
  const valor1 = 10
  const valor2 = 20
  const suma = valor1 + valor2
  console.log(suma)
}

sumar()
`,
        solucion: "30"
      },{
        codigo:3,
        descripcion: ` En caso de tratar de acceder a las variables definidas dentro de una función desde fuera se genera un error en nuestro programa.`,
programa: `function sumar() {
  const valor1 = 10
  const valor2 = 20
  const suma = valor1 + valor2
}

sumar()
console.log(suma)
`,
        solucion: "error"
      },{
        codigo:4,
        descripcion: `Todo el algoritmo de la función debe ir encerrada entre llaves de apertura y cerrado.`,
programa: `function sumar() 
  let valor1 = 10
  let valor2 = 20

sumar()
console.log(suma)
`,
        solucion: "error"
      },{
        codigo:5,
        descripcion: `El nombre de la función no puede empezar con un número, ni tener espacios en blanco.`,
programa: `function 2sumar() {
  const valor1 = 10
  const valor2 = 20
  const suma = valor1 + valor2
  console.log(suma)
}
2sumar()
`,
        solucion: "error"
      },{
        codigo:6,
        descripcion: ``,
programa: `function tabla5() {
  const tabla = []
  for (let i = 1; i <= 10; i++) {
    tabla.push(5*i)
  }
  console.log(tabla)
}

tabla5()
`,
        solucion: "[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]"
      },{
        codigo:7,
        descripcion: `Si bien no es aconsejable, podemos acceder a una variable definida fuera de una función.`,
programa: `let altura=10

function imprimirAltura() {
  console.log(altura)
}

imprimirAltura()
`,
        solucion: "10"
      },{
        codigo:8,
        descripcion: `Por supuesto que una variable definida dentro de una función no se puede acceder en otra función. Genera un error.`,
programa: `function funcion1() {
  let altura = 100
}

function funcion2() {
  console.log(altura)
}

funcion2()
`,
        solucion: "error"
      }
      ,{
        codigo:9,
        descripcion: `Desde una función podemos llamar a otra función, directamente mediante su nombre y los paréntesis abiertos y cerrados.
En el ejemplo siguiente llamamos desde la función funcion1 a la función funcion2. No hay que olvidar que luego de codificar las dos funciones debemos llamar a la funcion1.`,
programa: `function funcion1() {
  let altura1 = 100
  funcion2()
}

function funcion2() {
  let altura2 = 200
  console.log(altura2)
}

funcion1()
`,
        solucion: "200"
      },{
        codigo:10,
        descripcion: `Una función puede ser llamada antes de su declaración, esto es posible ya que el interprete de JavaScript identifica todas las funciones antes de comenzar con las instrucciones de llamadas.`,
programa: `sumar()

function sumar() {
  let suma = 2 + 5
  console.log(suma)      
}
`,
        solucion: "7"
      }
    ]
  }

export default funcion1;